import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { LoginComponent } from './Components/login/login.component';
import { LoginService } from './services/login/login.service';
import {PagerService} from './Services/pager.service';
import { HomeLayoutComponent } from './Components/Layout/HomeLayout.Component';
import { ProfileComponent } from './Components/profile/profile.component';
import { LoginLayoutComponent } from './Components/Layout/LoginLayout.Component';
import { AuthGuard } from './auth.guard';
import { HomeComponent } from './Components/home/home.component';
import { MatSnackBarComponent } from './Components/mat-snack-bar/mat-snack-bar.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { SelectAutocompleteModule } from 'mat-select-autocomplete';
import { ToastrModule } from 'ngx-toastr';
import {NgxPaginationModule} from 'ngx-pagination';
// search module
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { OrderModule } from 'ngx-order-pipe';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EncryptionDecryptionService } from './Services/encryption-decryption/encryption-decryption.service';
import { MaterialAllocationComponent } from './Components/material-allocation/material-allocation.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
} from '@angular/material';
import { DragDirective } from './drag-drop.directive';
import { AnnualRequirementComponent } from './Components/annual-requirement/annual-requirement.component';
import { InventoryManagementComponent } from './Components/inventory-management/inventory-management.component';
import { FinalRequirementComponent } from './Components/final-requirement/final-requirement.component';
import { UnitPriceComponent } from './Components/unit-price/unit-price.component';
import { VendorFinalizationComponent } from './Components/vendor-finalization/vendor-finalization.component';
import { PoStatusUpdateComponent } from './Components/po-status-update/po-status-update.component';
import { AdditionalRequirementComponent } from './Components/additional-requirement/additional-requirement.component';
import { ProductConfigurationComponent } from './Components/product-configuration/product-configuration.component';
import { MaStateMappingComponent } from './Components/state-mapping/ma-state-mapping.component';
import { ArtworksSpecificationComponent } from './Components/artworks-specification/artworks-specification.component';
import { JobSpecificationComponent } from './Components/job-specification/job-specification.component';
import { BrandMappingComponent } from './Components/brand-mapping/brand-mapping.component';
import { ApprovalStatusReportComponent } from './Components/approval-status-report/approval-status-report.component';
import { WHStockInComponent } from './Components/whstock-in/whstock-in.component';
import { ProductionPrintingComponent } from './Components/production-printing/production-printing.component';
import { MaterialDispatchComponent } from './Components/material-dispatch/material-dispatch.component';
import { ArtworkComponent } from './Components/artwork/artwork.component';
import { VendorDetailsComponent } from './Components/vendor-details/vendor-details.component';
import { TimelineSettingComponent } from './Components/timeline-setting/timeline-setting.component';
import { ProductionPackageingComponent } from './Components/production-packageing/production-packageing.component';
import { ZmhRequirementapprovalComponent } from './Components/zmh-requirementapproval/zmh-requirementapproval.component';
import { AnnualRequirementStatusReportComponent } from './Components/annual-requirement-status-report/annual-requirement-status-report.component';
import { JobnumberCancellationComponent } from './Components/jobnumber-cancellation/jobnumber-cancellation.component';

import { Injectable } from '@angular/core';
import { Request, XHRBackend, RequestOptions, Response, Http, RequestOptionsArgs, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { AuthService } from './services/auth.service';
import { WorkerAddressComponent } from './Components/worker-address/worker-address.component';
import { BulkUploadComponent } from './Components/bulk-upload/bulk-upload.component';


@Injectable()
export class httpinterceptService extends Http {

  constructor(backend: XHRBackend, defaultOptions: RequestOptions, private router: Router) {
    super(backend, defaultOptions);
  }
 // localHost = 'http://localhost:4200/';
  localHost = 'http://169.38.100.202:9246/';
  //localHost = 'http://169.38.100.206:9254/';
  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {  
    return super.request(url, options).catch(this.catchErrors());
  }

  private catchErrors() {
    return (res: Response) => {
      if (res.status === 401 || res.status === 403) {
        window.location.href = this.localHost + "#";
      }
      return Observable.throw(res);
    };
  }
}

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    children: [
      { path: '', component: LoginComponent, pathMatch: 'full' },
      { path: 'MCMaterial/Login', component: LoginComponent }
    ]
  },
  {
    path: '',
    component: HomeLayoutComponent,
    children: [
      { path: 'MCMaterial/Dashboard', component: HomeComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/AnnualRequirement', component: AnnualRequirementComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/Profile', component: ProfileComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/InventoryManagement', component: InventoryManagementComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/FinalRequirement', component: FinalRequirementComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/UnitPrice', component: UnitPriceComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/VendorFinalization', component: VendorFinalizationComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/POtoVendors', component: PoStatusUpdateComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/AdditionalRequirement', component: AdditionalRequirementComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/ProductConfiguration', component: ProductConfigurationComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/MAStateMapping', component: MaStateMappingComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/ArtworksSpecification', component: ArtworksSpecificationComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/JobSpecification', component: JobSpecificationComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/BMBrandMapping', component: BrandMappingComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/ApprovalStatusReport', component: ApprovalStatusReportComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/MaterialAllocation', component: MaterialAllocationComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/ProductionApproval', component: ProductionPrintingComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/MaterialDispatch', component: MaterialDispatchComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/ArtworkApproval', component: ArtworkComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/VendorDetails', component: VendorDetailsComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/WarehouseStockIn', component: WHStockInComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/ProductionPackageing', component: ProductionPackageingComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/TimelineSettings', component: TimelineSettingComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/AnnualRequirementApproval', component: ZmhRequirementapprovalComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/AnnualStatusReport', component: AnnualRequirementStatusReportComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/AdditionalRequirementApproval', component: FinalRequirementComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/CancelJobNumber', component: JobnumberCancellationComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/AddressManagement', component: WorkerAddressComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'MCMaterial/BulkUpload', component: BulkUploadComponent, pathMatch: 'full', canActivate: [AuthGuard]},
    ]
  },
  { path: '**', redirectTo: 'MCMaterial/Login' }
]

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    OrderModule,
    PdfViewerModule
  ],

  //declarations: [JobnumberCancellationComponent],
  //declarations: [WorkerAddressComponent],
  //declarations: [ZmhRequirementapprovalComponent],
  //declarations: [AnnualRequirementStatusReportComponent],
 // declarations: [ProductionPackageingComponent],
  //declarations: [WHStockInComponent],
  //declarations: [VendorDetailsComponent],
  //declarations: [MaterialDispatchComponent],
  //declarations: [ProductionPrintingComponent],
  //declarations: [ApprovalStatusReportComponent],

  //declarations: [AdditionalRequirementComponent],
  //declarations: [BrandMappingComponent],
  //declarations: [JobSpecificationComponent],
  //declarations: [ArtworksSpecificationComponent],
  //declarations: [MaStateMappingComponent],
  //declarations: [ProductConfigurationComponent],
  //declarations: [AnnualRequirementComponent]
  //declarations: [ProfileComponent, FinalRequirementComponent]

})
export class DemoMaterialModule { }

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    MatSnackBarComponent,
    HomeLayoutComponent,
    LoginLayoutComponent,
    DragDirective,
    AnnualRequirementComponent,
    InventoryManagementComponent,
    ProfileComponent, 
    FinalRequirementComponent,
    UnitPriceComponent,
    VendorFinalizationComponent,
    PoStatusUpdateComponent,
    AdditionalRequirementComponent,
   ProductConfigurationComponent,
   MaStateMappingComponent,
   ArtworksSpecificationComponent,
   JobSpecificationComponent,
   BrandMappingComponent,
   InventoryManagementComponent,
   ProfileComponent, 
   FinalRequirementComponent,
   ApprovalStatusReportComponent,
   VendorDetailsComponent,
   WHStockInComponent,
   MaterialAllocationComponent,
   ProductionPrintingComponent,
   MaterialDispatchComponent,
   ArtworkComponent,
   VendorDetailsComponent,
   TimelineSettingComponent,
   ProductionPackageingComponent,
   ZmhRequirementapprovalComponent,
   AnnualRequirementStatusReportComponent ,
   JobnumberCancellationComponent,
   WorkerAddressComponent,
   BulkUploadComponent

  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    MatSnackBarModule,
    NgxPaginationModule,
    HttpClientModule,
    DemoMaterialModule,
    Ng4LoadingSpinnerModule.forRoot(),
    SelectAutocompleteModule,
    ToastrModule.forRoot({ timeOut: 15000,
      preventDuplicates: true,
      maxOpened: 1,
      autoDismiss: true,
      extendedTimeOut:3000 }),
    RouterModule.forRoot(routes, { useHash: true }),
    Ng2SearchPipeModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
    {
          provide: Http,
          useFactory: (backend: XHRBackend, options: RequestOptions,  router: Router) => {
            return new httpinterceptService(backend, options,  router);
          },
          deps: [XHRBackend, RequestOptions, AuthService, Router]
       },LoginService,EncryptionDecryptionService,AuthGuard, MatSnackBarComponent, MatDatepickerModule,PagerService
    ],
  //providers: [LoginService,EncryptionDecryptionService,AuthGuard, MatSnackBarComponent, MatDatepickerModule,PagerService],
  bootstrap: [AppComponent]
})
export class AppModule { }
